import Vue from 'vue'

const TREATMENT_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};


const TREATMENT_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};

const TREATMENT_SET_TREATMENTS =(state, payload)=> {  
    
    state.treatments=payload
    
};

const TREATMENT_SET_TREATMENT =(state, payload)=> {       
    
    state.data.name = payload.name
        
};

const TREATMENT_INIT_TREATMENT =(state, payload)=> {       
    state.data.name = ''    
    
};



export default {
    TREATMENT_SET_NAME,
    TREATMENT_SET_DUPLICATE,
    TREATMENT_SET_TREATMENTS,
    TREATMENT_SET_TREATMENT,
    TREATMENT_INIT_TREATMENT,
};